import styled from "styled-components";

export const Main = styled.div`
   .popupLog {
      display: flex;

      .direct {
         width: 550px !important;
      }
      .log {
         margin-left: 7.5px;

         ul {
            overflow: auto;

            li {
               display: flex;
               align-items: flex-start;
               line-height: 1.3;
               color: #db2c2c;
               background-color: rgba(219, 44, 44, 0.1);
               // border-radius: 5px;
               padding: 7.5px 15px;
               font-size: 16px;

               &:not(:last-of-type) {
                  margin-bottom: 7.5px;
               }
               span {
                  // margin-right: 7.5px;

                  /* &:first-of-type {
                     padding: 7.5px 15px;
                     border-radius: 5px;
                     background-color: rgba(30, 39, 46, 0.07);
                  } */
               }
            }
         }
      }
   }
`;